/* eslint-disable jsx-a11y/no-onchange */
/* eslint-disable jsx-a11y/aria-proptypes */
import React, { useEffect, useState, useCallback } from 'react';

import MultiselectResultSet from './MultiSelectResultSet/MultiSelectResultSet'
import './MultiSelect.scss';
import { CBDropdown } from '../../constants/apricotCBform';
import {ToolTip} from '../';


const MultiSelect = ({apcp, question_tooltip, org_rol, children,  selectId, halfInput, isRequired, selectLabel, selectData, selectValue, onChangeSelectValue, readOnly }) => {

  const [answer, setAnswer] = useState();

  useEffect(() => {
    document.querySelectorAll(".cb-dropdown").forEach((elem) => {
        CBDropdown({
          elem: elem
        });
      });
  });

  useEffect(()=>{
    const arr = selectValue? selectValue.split('|'):[];
    setAnswer(arr);
  }, [selectValue]);

  const populateResult = useCallback(item => {
    if(!answer.includes(item)){
      answer.push(item);
      setAnswer(state =>answer);  
      onChangeSelectValue(answer.join('|'));
    }
    else{
      removeSelection(item);
    }
  });

  const handleKeydown = useCallback((event, item, selectId) =>{
    event.preventDefault();
    if (event.keyCode == 32) {
      if(!answer.includes(item)){
        populateResult(item);
      }
      else{
        removeSelection(item);
      }
    }
    if(event.keyCode==13){
      const resultdiv = document.getElementById(`multiselectResult-${selectId}`);
      if(resultdiv){
        const atags = resultdiv.getElementsByTagName('a');
        const aelements = Array.from(atags);
        const focustags = aelements?.filter(el => el.firstChild.innerText===item)
        if(focustags&&focustags.length>0) {
          document.getElementById(focustags[0].id).focus();
        }
        else {
          document.getElementById(`border-${selectId}`).focus();
        }
      }
      else {
        document.getElementById(`border-${selectId}`).focus();
      }
      document.getElementById(`div-${selectId}`).classList.remove('cb-open');
      document.getElementById(`div-${selectId}`).classList.add('cb-close');
    }
  });


  const clearResult = useCallback((e, id) => {
    const ele = document.getElementById(id);
    if(ele.hasAttribute("disabled")){
      ele.click();
    }
    else{
      e.preventDefault();
      setAnswer(() =>[]);
      onChangeSelectValue('');
    }
  });

  const removeSelection = useCallback((item, e)=>{
    if(e) e.preventDefault();
    const newanswer = answer.filter(el => { 
      return el !== item});
    setAnswer(()=>newanswer);
    onChangeSelectValue(newanswer.join('|'));
  })

  const GenerateList = (optionData) => {
    return optionData?.map((item, index) =>{
      const showCheck = answer?.includes(item)? true:false;
      return (<li role='presentation' key={`k-${selectId}-${index}`}>
          <a id={`item-${selectId}-${index}`} role='option' tabIndex='0' 
          onClick={()=>{populateResult(item)}}
          onKeyDown={event=>{handleKeydown(event, item, `${selectId}`)}}
          onFocus={()=>{document.getElementById(`item-${selectId}-${index}`).setAttribute('aria-selected', true)}}
          onBlur={()=>{document.getElementById(`item-${selectId}-${index}`).setAttribute('aria-selected', false)}}
          aria-checked={`${showCheck?true:false}`}          
          >{item}
          <span className={`${showCheck?'':'cb-hidden'} cb-icon cb-check`}>
          </span>
          </a> 
      </li>);
      });
  };

  const highlightBox = (divId) => {
    document.getElementById(divId).classList.add('highlight');
  }

  const blurOut = (divId) => {
    document.getElementById(divId).classList.remove('highlight');
  }

  const optionselectdata = selectData === null ? [] : selectData;

  return (
    <div className='multicontainer col-md-12' id={`container-${selectId}`}>
      <div id={`selectid1-${selectId}`}>
        <div id={`selectid2-${selectId}`}>
          
          <div className={`display-flex ${halfInput?'col-md-12':'col-md-6'}`} >
            {children}
            <label id={`label-${selectId}`} htmlFor={`multi`+selectId} className={`${(isRequired) ? 'cb-required' : ''}`}>
              {selectLabel}
            </label>
            {
              !apcp&&question_tooltip?<ToolTip tooltipid={`smartdisplayMulti${selectId}id`} 
                                        tooltipMsg={question_tooltip} 
                                        innerMsg={<span className="cb-icon cb-user"></span>} 
                                        className={'questionToolTip'}
                                        />
                                        :''
            }
          </div>

          <div className={`border ${halfInput?'col-md-12':'col-md-6'}`} id={`multi${selectId}`}>
          <MultiselectResultSet id={`mulsel${selectId}`} selectValue={answer} selectLabel={selectLabel} onClear={clearResult} onRemove={removeSelection} readOnly={readOnly}/>
         
          <div className="cb-dropdown nobox" id={`div-${selectId}`}>
            <a href='#' className="cb-dropdown-toggle col-md-12" id={`dropdown-${selectId}`}
              role="button"
              style={readOnly?{pointerEvents:'none', color:'#888888'}:{}}
              onFocus={()=>{highlightBox(`div-${selectId}`)}}
              onBlur={()=>{blurOut(`div-${selectId}`)}}
              aria-expanded="false"
              aria-labelledby={`label-${selectId}`}
              aria-describedby={`title-${selectId}`}
              aria-haspopup="listbox"
              aria-controls={`dropdownMenu-${selectId}`}>
              <span className='dropdownTitle' id={`title-${selectId}`}>Select Values</span>
              <i className="cb-icon cb-down rightIcon" aria-hidden="true" id={`down-${selectId}`}></i>
              <i className="cb-icon cb-up cb-hidden rightIcon" aria-hidden="true" id={`up-${selectId}`}></i>
            </a>
            <div className="cb-dropdown-menu cb-box-shadow">
              <ul role="listbox" aria-labelledby={`dropdown-${selectId}`} 
              id={`dropdownMenu-${selectId}`}
              aria-multiselectable="true"
              aria-labelledby={`label-${selectId}`}
              aria-controls={`multiselectResult-${selectId}`}
              >
              {GenerateList(optionselectdata)}
              </ul> 
            </div>
          </div>
          </div>
          
        </div>
      </div>
      <p id={`selectid4-${selectId}`} style={{display: 'none'}}>Success</p>
      <p id={`selectid5-${selectId}`} style={{display: 'none'}}>Error</p>
    </div>);
};

export default MultiSelect;